import { AxiosInstance } from 'axios'

export type GetOriginalPdfParams = {
  documentUUID: string
}

export type GetOriginalPdfResponse = {
  data: Blob
  error?: unknown
}

export const getOriginalPdf = async (
  svcCrunchApiClient: AxiosInstance,
  { documentUUID }: GetOriginalPdfParams
): Promise<GetOriginalPdfResponse> => {
  try {
    const { data: responseData } = await svcCrunchApiClient.get<ArrayBuffer>(
      `/api/documents/${documentUUID}/original-pdf`,
      {
        responseType: 'arraybuffer',
      }
    )

    return {
      data: new Blob([responseData], {
        type: 'application/pdf',
      }),
    }
  } catch (error) {
    return {
      data: new Blob([]),
      error,
    }
  }
}
